module.exports = __webpack_public_path__ + "img/cass4.1147a8e1.jpg";